import { apiService } from '../api';

export interface InviteCheckRequest {
  inviteId: string;
  userId: string;
}

export interface InviteCheckResponse {
  query: string;
  result: unknown;
  error: string;
  totalResults: number;
  pageNo: number;
  message: string;
}

export type InviteType = 'clan' | 'organization' | 'team';

class InviteService {
  private static instance: InviteService;

  private constructor() {}

  public static getInstance(): InviteService {
    if (!InviteService.instance) {
      InviteService.instance = new InviteService();
    }
    return InviteService.instance;
  }

  async checkClanInvite(
    inviteId: string,
    data: InviteCheckRequest,
  ): Promise<InviteCheckResponse> {
    return apiService.post<InviteCheckResponse, InviteCheckRequest>(
      `/private/api/v1/clan/${inviteId}/checkInviteLink`,
      data,
    );
  }

  async checkOrganizationInvite(
    inviteId: string,
    data: InviteCheckRequest,
  ): Promise<InviteCheckResponse> {
    return apiService.post<InviteCheckResponse, InviteCheckRequest>(
      `/private/api/v1/organization/${inviteId}/checkInviteLink`,
      data,
    );
  }

  async acceptTeamInvite(teamId: string, data: unknown): Promise<unknown> {
    return apiService.post(`/private/api/v1/team/${teamId}/team-invite`, data);
  }
}

export const inviteService = InviteService.getInstance();
